import type {HistoryItem} from '@AiChat/ai-chat.types';
import {AI_CHAT_QUICK_TIPS_URL_SEGMENT, AI_CHAT_ROOT_URL_SEGMENT} from '@AiChat/ai-chat.types';

export const getHistory = async (searchQuery: string | undefined, offset = 0, limit = 20): Promise<HistoryItem[]> => {
  return (await window.PMW.readLocal('ai/history', {
    offset,
    limit,
    searchQuery,
  })) as HistoryItem[];
};

const getLastPathSegment = (): string => {
  const pathParts = window.location.pathname.split('/').filter((part) => part.length > 0);
  return pathParts[pathParts.length - 1] ?? '';
};

export const isQuickTipsUrl = (): boolean => {
  return getLastPathSegment() === AI_CHAT_QUICK_TIPS_URL_SEGMENT;
};

export const getChatIdFromUrl = (): string | undefined => {
  const lastPart = getLastPathSegment();

  if (lastPart === AI_CHAT_ROOT_URL_SEGMENT || lastPart === AI_CHAT_QUICK_TIPS_URL_SEGMENT) {
    return undefined;
  }

  return lastPart;
};

export const getAiChatBasePath = (): string => {
  const path = window.location.pathname;
  const hasSegment = Boolean(getChatIdFromUrl()) || isQuickTipsUrl();
  return hasSegment ? path.substring(0, path.lastIndexOf('/')) : path;
};

export const getChatUrl = (chatId: string): string => {
  return `${getAiChatBasePath()}/${chatId}`;
};
